export default __webpack_public_path__ + "static/N0037-ca70b57be7bdf9f8b1866d77bc702d47.png";